<ng-container *transloco="let t">
  <div class="access-denied">
    <h2>{{ t('accessDenied.title') }}</h2>
    <p>{{ t(message) }}</p>

    <div class="actions">
      <button class="logout" (click)="logout()">
        {{ t('accessDenied.logout') }}
      </button>
    </div>
  </div>
</ng-container>
